import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import CardGiftcardOutlined from '@material-ui/icons/CardGiftcardOutlined';
import SportsEsportsOutlined from '@material-ui/icons/SportsEsportsOutlined';
import TrendingUpOutlined from '@material-ui/icons/TrendingUpOutlined';

const useStyles = makeStyles((theme) => ({
  background: {
    padding: 80,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    paddingLeft: 50,
    paddingRight: 50,

    [theme.breakpoints.down('sm')]: {
      paddingLeft: 10,
      paddingRight: 10,
      padding: 10,
      paddingBottom: 35,
      paddingTop: 60,
      display: 'flex',
      justifyContent: 'center',
    },
  },
  itemsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginTop: 20,
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  item: {
    marginBottom: 40,
    maxWidth: 400,
    marginLeft: 12,
    marginRight: 12,
    backgroundColor: 'black',
    padding: 30,
    height: '350px',
    [theme.breakpoints.down('md')]: {
      height: '100%',
    },
  },
  heading: {
    // color: theme.palette.pbr.textPrimary,
    color: theme.palette.pbr.heading,
    textAlign: 'left',
    fontSize: 36,
    fontWeight: 600,
    verticalAlign: 'middle',
    wordSpacing: '0px',
    alignSelf: 'center',
    paddingTop: 0,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 15,
      fontSize: 24,
      marginBottom: 25,
    },
  },
  subHeading: {
    color: theme.palette.pbr.textPrimary,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 15,
      marginBottom: 25,
    },
  },
  para: {
    color: theme.palette.pbr.textPrimary,
    verticalAlign: 'baseline',
    // letterSpacing: "-0.7px",
    margin: 0,
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: 'left',
    height: 'auto',
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      paddingTop: 5,
      marginTop: 0,
    },
  },
  subheading: {
    color: theme.palette.pbr.textPrimary,
  },
}));

const Feature = () => {
  const classes = useStyles();
  return (
    <div className={classes.background}>
      <h6 className={classes.heading}>Peacock Products</h6>

      <div className={classes.itemsContainer}>
        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" />
            Serrum (BSC Network)
          </h5>
          <p className={classes.para}>
          A Decentralized Marketplace for Lenders and Borrowers with Borderless NFTs Token.
          <br></br><p></p>soon</p>
        </div>

        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" /> The Box (BSC Network)
          </h5>
          <p className={classes.para}>
          The Box Token is a multi-use case DEFI BSC Token in the The Box Token Ecosystem.
          <br></br><p></p>Website: https://thebox.fun</p>
        </div>

        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" /> Victory Token (BSC Network)
          </h5>
          <p className={classes.para}>
          A Decentralized Marketplace for Lenders and Borrowers with Borderless Stablecoins.
            <br></br><p></p>Website: https://victorytoken.xyz</p>
        </div>        
      </div>
      <div className={classes.itemsContainer}>
        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" />
            Circle Token (BSC Network)
          </h5>
          <p className={classes.para}>
          Our project development just started and yet we have achieved numerous milestones. Our team is working hard to keep Circle Token on the verge of innovation in the DeFi space.
          <br></br><p></p>Website: soon</p>
        </div>

        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" /> Kretek (Matic Network)
          </h5>
          <p className={classes.para}>
          The future shines brightly with unrestricted growth, global adoption, permissionless innovation, and decentralized development.
          <br></br><p></p>Website: https://kretek.padiswap.com</p>
        </div>

        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" /> Kucica (Fantom Network)
          </h5>
          <p className={classes.para}>
          Kucica is a community-focused, decentralized cryptocurrency with instant rewards thanks to active users! Join the moon mission.
            <br></br><p></p>Website: soon</p>
        </div>        
      </div>
      <div className={classes.itemsContainer}>
        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" />
            Moto (Matic Network)
          </h5>
          <p className={classes.para}>
          We built this on Matic Polygon Chain to save cost on transactions- more money to beautify your Eyes. Think of $MOTO as a saving account to beautify your Eyes and nothing is wrong with making huge profit on it!.
            <br></br><p></p>Website: soon</p>
        </div>

        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" /> Crackle (Fantom Network)
          </h5>
          <p className={classes.para}>
          CRACLE is a platform for the future of funding that is built on top of the Fantom Chain blockchain. It accelerates growth of start-up companies by offering tools and services that save both time and resources.
            <br></br><p></p>Website: soon</p>
        </div>

        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" /> Potlot (BSC Network)
          </h5>
          <p className={classes.para}>
          Potlot Token which is a new revolutionary project and the future of merchant crypto payments that allows all $PTN ($PTN) HODLERS to generate infinite passive rewards in the form of BNB & $PTN!.
            <br></br><p></p>Website: soon</p>
        </div>        
      </div>
      <div className={classes.itemsContainer}>
        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" />
            Padi Swap (Celo Network)
          </h5>
          <p className={classes.para}>
          Multi-Chain AMM and Yield Farm With Innovative Features. On #Celo.
          <br></br><p></p>Website: https://celo.padiswap.com</p>
        </div>

        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" /> Hammer (Matic Network)
          </h5>
          <p className={classes.para}>
          Earn $Matic, $Polygon by Hold $HMR on the Polygon Chain.
          <br></br><p></p>Website: https://hammer.padiswap.com</p>
        </div>

        <div className={classes.item}>
          <h5 className={classes.subheading}>
            <CardGiftcardOutlined fontSize="large" /> Update (soon)
          </h5>
          <p className={classes.para}>
          soon
            <br></br><p></p>Website: https://maksubasi.blogspot.com</p>
        </div>        
      </div>
    </div>
  );
};

export default Feature;
